var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.78 16.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "linkedin-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.27,83.4h3.78V72H66.27Zm1.94-13c.12,0,.3,0,.47,0a1.93,1.93,0,0,0,1.59-1.5,2,2,0,0,0-.8-2,2.38,2.38,0,0,0-1.65-.34,2,2,0,0,0-1.57,2.86A2,2,0,0,0,68.21,70.39Z",
    transform: "translate(-66.03 -66.43)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.81,83.42H80v-.23c0-2,0-4.07,0-6.11a4.29,4.29,0,0,0-.2-1.18,1.68,1.68,0,0,0-1.86-1.2,2.08,2.08,0,0,0-1.85,1.56,3.65,3.65,0,0,0-.08.88v6.27h-3.8V72H76v1.59l.24-.33a3.74,3.74,0,0,1,3.22-1.54,4.44,4.44,0,0,1,2.28.59,4,4,0,0,1,1.59,1.88,6.48,6.48,0,0,1,.46,2,1.92,1.92,0,0,0,0,.22Z",
    transform: "translate(-66.03 -66.43)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.27,83.4V72h3.78V83.4Z",
    transform: "translate(-66.03 -66.43)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.21,70.39a2,2,0,0,1-2-1.08,2,2,0,0,1,1.57-2.86,2.38,2.38,0,0,1,1.65.34,2,2,0,0,1,.8,2,1.93,1.93,0,0,1-1.59,1.5C68.51,70.37,68.33,70.38,68.21,70.39Z",
    transform: "translate(-66.03 -66.43)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.88d7454f76153fcecd31a44d74bc76f4.svg";
export { ForwardRef as ReactComponent };